export const MODELS = [
  { value: "cashback", label: "Cashback" },
  { value: "points", label: "Pontos" },
];

export const PLANS = [
  { value: "premium", label: "Takeat" },
  { value: "banestes", label: "Banestes" },
];
